import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { IcoEmojiInsatisfacao, IcoPaste, IcoShrink, IcoStar, Loading, Tab, PopoverCentralAjuda } from '../../../components'
import { useParams } from "react-router-dom";
import { history, numberAleatori } from '../../../helpers';

export default ({ nlsContexto, nls, imprimir }) => {
  const dispatch = useDispatch()
  const { IdSwot, idProjetos } = useParams()
  const { swots, loadSwots } = useSelector(state=> state.swotState)
  const [IdSwotTab, setIdSwotTab] = useState('')

  const idarray = [216];


  useEffect(()=> {
    if (IdSwot) { setIdSwotTab(IdSwot) }
  }, [IdSwot])

  const handleSwot = (e) => {
    setIdSwotTab(e)
    //history.push(`/meusprojetos/${idProjetos}/analiseswot/${e}`)
    history.push(`/myprojects/${idProjetos}/swotanalysis/${e}`)
  }
  
  const labelsType = [ 'Satisfação geral', 'Insatisfação geral', 'Pilares', 'Indicadores' ]
  const swotIcon = (e) => {
    switch (e) {
      case 'Satisfação geral':
        return <IcoStar />;
      case 'Insatisfação geral':
        return <IcoEmojiInsatisfacao />;
      case 'Pilares':
        return <IcoPaste />;
      case 'Indicadores':
        return <IcoShrink />;
      default:
        return <IcoStar />;
    }
  }

  

  const tabContent = (e) => {
    const content = e?.map(tab=> {
      const swotsList = tab?.swot.map(swot=> {
        let swotDatab = swot.info
        if (typeof swot.info === 'string') {
          swotDatab = <div className='box-swot-content-info-list'>
              {swot.info.x? <span className='box-swot-content-info-list-loja'>{swot.info.x}</span>:null}
              <p>{swot.info}</p>
          </div>
        } else if ( typeof swot.info === 'object') {
          swotDatab = swot?.info.map(loja=> {
            return <div key={`tab-${tab.id}-swot${swot?.label}-loja-${loja}-${numberAleatori()}`} className='box-swot-content-info-list'>
            {loja.x? <span className='box-swot-content-info-list-loja'>{loja.x}</span>:null}
              <p>{loja}</p>
            </div>
          })
        }
        return <div key={`tab-${tab.id}-swot${swot?.label}`} className='box-swot-content-info'>
          <h3>{swotIcon(swot?.label)} {swot?.label}</h3>
            {swotDatab}
        </div>
      })

      return {
        id: tab.id,
        title: tab.title,
        content: (
          <div className="box-swot-content">
            <h2 className="box-swot-content-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {tab.title}
              <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray} />
            </h2>
            {swotsList}
          </div>
        ),
      }
    })
    return content
  }
  
  if (!imprimir) {
    return (
      <div className="box-swot box-content box-swot-mensagem">
        <p>{nls.semdadosparaexibir}</p>
      </div>
    );
  }

  return loadSwots?
  <Loading type='element' title='' height='300px' />
  :(
    <div className='box-swot'>
      <Tab
        actionTab={(e)=> handleSwot(e)}
        tabSelect={IdSwotTab}
        data={tabContent(swots)}
      />
    </div>
  )
}
